import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { CounterInfo } from '@/components/counters/types/CounterTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfGrayCounterComponent',
  props: {
  info: {
    type: Object as PropType<CounterInfo>,
    required: true
  }
},
  setup(__props) {

const { info } = __props;



return { __sfc: true, }
}

})